module.exports = __webpack_public_path__ + "img/mapa_en (2).818a4e1e.jpg";